import React, { forwardRef } from 'react'
import NextLink from 'next/link'
import clsx from 'clsx'
import { type Route } from 'next'

export type LinkProps<T extends string> = { href: Route<T> | undefined; disabled?: boolean } & Omit<
  React.ComponentPropsWithoutRef<typeof NextLink>,
  'href'
>

export const Link = forwardRef(function Link<T extends string>(
  { className, disabled, href, ...props }: LinkProps<T>,
  ref: React.ForwardedRef<HTMLAnchorElement>,
) {
  if (disabled || !href) {
    return (
      // eslint-disable-next-line jsx-a11y/anchor-has-content
      <a
        className={clsx(className, 'text-button1 outline-none focus-visible:ring-2 ring-fuse-orange')}
        {...props}
        ref={disabled ? undefined : ref}
        href={undefined}
      />
    )
  }
  if (
    href?.startsWith('http://') ||
    href?.startsWith('http://') ||
    href?.startsWith('mailto:') ||
    href?.startsWith('tel:')
  ) {
    return (
      // eslint-disable-next-line jsx-a11y/anchor-has-content
      <a
        className={clsx(className, 'text-button1 outline-none focus-visible:ring-2 ring-fuse-orange')}
        {...props}
        ref={disabled ? undefined : ref}
        href={href}
      />
    )
  }
  return (
    <NextLink
      className={clsx(className, 'text-button1 outline-none focus-visible:ring-2 ring-fuse-orange')}
      {...props}
      ref={disabled ? undefined : ref}
      href={href}
    />
  )
}) as <T extends string>(
  props: LinkProps<T> & { ref?: React.ForwardedRef<HTMLAnchorElement> },
) => React.ReactElement<any>
